module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("your Dashboard")]), _vm._v(" "), _c('div', [_c('div', [_c('h5', [_vm._v("All questions " + _vm._s(_vm.getCategoryIntersect(_vm.all)) + "/" + _vm._s(_vm.all.length) + " ")]), _vm._v(" "), _c('skillbar', {
    attrs: {
      "progress": _vm.getCategoryIntersectPercent(_vm.all)
    }
  }), _vm._v(" "), (_vm.all.length != _vm.getCategoryIntersect(_vm.all)) ? _c('button', {
    staticClass: "x-btn x-btn-small",
    on: {
      "click": function($event) {
        _vm.startTestAll(true)
      }
    }
  }, [_vm._v("continue")]) : _vm._e(), _vm._v(" "), (_vm.all.length == _vm.getCategoryIntersect(_vm.all)) ? _c('button', {
    staticClass: "x-btn x-btn-small",
    on: {
      "click": function($event) {
        _vm.startTestAll(false)
      }
    }
  }, [_vm._v("test")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', _vm._l((_vm.categories), function(category) {
    return _c('div', {
      staticClass: "progressbar"
    }, [_c('h5', [_vm._v(_vm._s(category.name) + " " + _vm._s(_vm.getCategoryIntersect(category.questions)) + "/" + _vm._s(category.questions.length) + " ")]), _vm._v(" "), _c('skillbar', {
      attrs: {
        "progress": _vm.getCategoryIntersectPercent(category.questions, category.questions.length)
      }
    }), _vm._v(" "), (category.questions.length != _vm.getCategoryIntersect(category.questions)) ? _c('button', {
      staticClass: "x-btn x-btn-small",
      on: {
        "click": function($event) {
          _vm.startTest(category, true)
        }
      }
    }, [_vm._v("continue")]) : _vm._e(), _vm._v(" "), (category.questions.length == _vm.getCategoryIntersect(category.questions)) ? _c('button', {
      staticClass: "x-btn x-btn-small",
      on: {
        "click": function($event) {
          _vm.startTest(category, false)
        }
      }
    }, [_vm._v("test")]) : _vm._e()], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ad4388d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Journey.vue
// module id = 47
// module chunks = 0